import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'
import slugify from 'slugify'

import ContactItem from '../contactItem'
import Wysiwyg from '../wysiwyg'

import ButtonArrow from '../buttonArrow'

import semiroundShape from '../../icons/semiround-shape.svg'
import hexagonShape from '../../icons/hexagon-shape.svg'
import roundShape from '../../icons/round-shape.svg'

import transformLink from '../../utils/transformLink'

const Tabs = ({data}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  // local state
  const initTab = slugify(data.items[0].fields ? data.items[0].fields.title : data.items[0].title)
  const [activePanel, setActivePanel] = useState(initTab)

  let cta = null
  
  if (data.cta !== null && data.cta !== undefined) {
    cta = (data.cta.fields) ? data.cta.fields : data.cta
  }

  const {url, contentTypeContentful} = transformLink(cta, true, false)

  return (
    <div className={`tabs-slice relative ${inView ? 'has-anim' : ''}`} ref={ref}>
      <svg className="absolute icon-sienne tabs-slice__semiround" width="96" height="113">
        <use xlinkHref={semiroundShape.url} />
      </svg>
      <svg className="absolute icon-night tabs-slice__hexagon" width="110" height="110">
        <use xlinkHref={hexagonShape.url} />
      </svg>
      <svg className="absolute icon-gradient-blue2 tabs-slice__round" width="88" height="88">
        <use xlinkHref={roundShape.url} />
      </svg>

      <div className="tabs-slice__inner has-full-bg">
        <div className="row">
          <div className="col-12 lg-col-8 mx-auto">
            { data.titleContent &&
              <h2 className="title title-slice mb-8 scroll-anim-el">{ data.titleContent }</h2>
            }

            <div className={`scroll-anim-el ${data.titleContent ? 'scroll-anim-el--2' : ''}`}>
              <ul className="flex overflow-auto md:overflow-hidden md:flex-wrap mb-16 tabs-slice__list">
                { data.items.map((item, i) => { 
                  const pill = (item.fields) ? item.fields : item
                  return(
                    <li className={`pr-4 md:mb-4`} key={i}>
                      <button 
                        className={`tabs-slice__pill ${activePanel === slugify(pill.title) && 'is-active'}`}
                        onClick={() => setActivePanel(slugify(pill.title))}>{pill.title}
                      </button>
                    </li>
                  )
                }) }
              </ul>

              <div className="tabs">
                { data.items.map((item, i) => { 
                  const panel = (item.fields) ? item.fields : item

                  return (
                    <TabsPanel key={i} activePanel={activePanel} item={panel} parentHasTitle={data.titleContent} />
                  )
                }) }
              </div>
            </div>

            { cta !== null &&
              <div className={`mt-6 md:mt-8 scroll-anim-el ${data.titleContent && data.titleContent !== '' ? 'scroll-anim-el--3' : 'scroll-anim-el--2'}`}>
                <ButtonArrow text={ cta.label } link={url} contentType={contentTypeContentful} color="night" />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

const TabsPanel = ({activePanel, item, parentHasTitle = false}) => {
  const content = item.content

  let ctaItem = null
  
  if (item.cta !== null && item.cta !== undefined) {
    ctaItem = (item.cta.fields) ? item.cta.fields : item.cta
  }

  const subLink = transformLink(ctaItem, true, false)
  const urlItem = subLink.url
  const contentTypeContentfulItem = subLink.contentTypeContentful

  return (
    <div className={`tabs__panel ${activePanel === slugify(item.title) ? 'is-active' : ''}`}>
      { parentHasTitle ?
        <h3 className="text-label text-label--big text-turquoise mb-6">{item.title}</h3>
        : <h2 className="text-label text-label--big text-turquoise mb-6">{item.title}</h2>
      }

      { parentHasTitle 
        ? <h4 className="title title-slice-medium block mb-5">{item.subtitle1}</h4>
        : <h3 className="title title-slice-medium block mb-5">{item.subtitle1}</h3>
      }

      <Wysiwyg document={content} classes={`text-night ${item.subtitle2 || item.contactItems ? 'mb-7 md:mb-8' : ''}`} />

      { item.subtitle2 &&
        <>
          { parentHasTitle 
            ? <h4 className="title title-slice-medium block mb-5">{item.subtitle2}</h4>
            : <h3 className="title title-slice-medium block mb-5">{item.subtitle2}</h3>
          }
        </>
      }

      { item.contactItems &&
        <div className="flex flex-wrap contact-card-tabs">
          { item.contactItems.map((item, i) => { 
            return(
              <div className="md:w-1/2 mb-7 md:mb-8 md:pr-8" key={i}>
                <ContactItem type="tab" data={item} />
              </div>
            )
          }) }
        </div>
      }

      { ctaItem !== null &&
        <div className="mt-6 md:mt-8 mb-7 md:mb-8">
          <ButtonArrow text={ ctaItem.label } link={urlItem} contentType={contentTypeContentfulItem} color="night" />
        </div>
      }
    </div>
  )
}

export default Tabs
